import React from 'react';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <span className="section-tag">Our Story</span>
          <h1>For the Hosts Who Want Magic Without the Mayhem</h1>
          <p className="hero-subtitle">
            We're here for the girlies and gays who don't want to email 9 florists 
            or pretend they know what a timeline is.
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="about-story">
        <div className="container">
          <div className="story-grid">
            <div className="story-image">
              <img 
                src="https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600" 
                alt="Elegant party setup with golden accents"
              />
              <div className="image-accent"></div>
            </div>
            <div className="story-content">
              <h2>The Midnight Beginning</h2>
              <p>
                Midnight Aurelia Events was born from a simple truth: you deserve a Pinterest-worthy 
                party without having to fight your printer or cry into a roll of tulle.
              </p>
              <p>
                We started when we realized that hosting a beautiful gathering shouldn't 
                require a degree in event planning, a second mortgage, or sacrificing your 
                sanity. You've got good taste, a limited budget, and decision fatigue. 
                Let's fix that.
              </p>
              <p>
                Every box, every service, every detail is curated with one goal: 
                making you look like you have your life together (even if you're still 
                in your pajamas two hours before guests arrive).
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="about-values">
        <div className="container">
          <span className="section-tag">What We Believe</span>
          <h2>Our Guiding Principles</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">✨</div>
              <h3>Style Without Stress</h3>
              <p>
                Beautiful gatherings shouldn't come with a side of anxiety. We handle 
                the details so you can actually enjoy being a host.
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">🎯</div>
              <h3>Curated, Not Generic</h3>
              <p>
                No tacky party store vibes here. Every item is thoughtfully selected 
                to create cohesive, Instagram-worthy moments.
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">💫</div>
              <h3>Luxury for Real Life</h3>
              <p>
                You shouldn't need a trust fund to throw a beautiful party. We bring 
                elevated aesthetics at accessible price points.
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">🌿</div>
              <h3>Sustainable Style</h3>
              <p>
                Our boxes include reusable elements and eco-friendly disposables. 
                Good taste and good conscience, together.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="about-process">
        <div className="container">
          <span className="section-tag">How We Work</span>
          <h2>From Vision to Celebration</h2>
          <div className="process-timeline">
            <div className="process-step">
              <div className="step-number">01</div>
              <div className="step-content">
                <h3>Share Your Vibe</h3>
                <p>
                  Tell us about your event, your aesthetic, and your wildest hosting dreams. 
                  We're great listeners (and even better curators).
                </p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">02</div>
              <div className="step-content">
                <h3>We Create the Magic</h3>
                <p>
                  Our team curates the perfect combination of decor, details, and design 
                  elements tailored to your vision and budget.
                </p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">03</div>
              <div className="step-content">
                <h3>Unbox & Set Up</h3>
                <p>
                  Everything arrives with clear instructions. Most setups take under an 
                  hour—leaving you time to actually get ready for your own party.
                </p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">04</div>
              <div className="step-content">
                <h3>Host Like a Pro</h3>
                <p>
                  Soak in the compliments, snap the photos, and enjoy the moment. 
                  You did that (with a little help from us).
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team/Founder Section */}
      <section className="about-founder">
        <div className="container">
          <div className="founder-grid">
            <div className="founder-content">
              <span className="section-tag">Meet the Curator</span>
              <h2>The Heart Behind the Magic</h2>
              <p>
                Midnight Aurelia Events was founded by a self-proclaimed "recovering perfectionist" 
                who threw one too many parties the hard way. After spending countless hours 
                sourcing the perfect napkins, creating DIY centerpieces that looked nothing 
                like Pinterest, and stress-crying before guests arrived, there had to be 
                a better way.
              </p>
              <p>
                Now, we pour that obsessive attention to detail into creating party experiences 
                that feel effortless for you. Because everyone deserves to enjoy their own 
                celebration.
              </p>
              <div className="founder-signature">
                <span>XOXO,</span>
                <span className="signature">Midnight Aurelia Events</span>
              </div>
            </div>
            <div className="founder-image">
              <img 
                src="https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=500" 
                alt="Curated party details"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="about-stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <span className="stat-number">500+</span>
              <span className="stat-label">Parties Styled</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">98%</span>
              <span className="stat-label">Happy Hosts</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">14</span>
              <span className="stat-label">Curated Themes</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">∞</span>
              <span className="stat-label">Compliments Received</span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <div className="container">
          <h2>Ready to Host Without the Headache?</h2>
          <p>
            Whether you want a curated box delivered to your door or full-service 
            styling, we've got you covered.
          </p>
          <div className="cta-buttons">
            <a href="/party-boxes" className="btn btn-primary">Shop Party Boxes</a>
            <a href="/services" className="btn btn-secondary">Explore Services</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
